import { AnimaliaListItem } from './AnimaliaListItem';
import { AnimaliaListingTaxonomy } from './AnimaliaListingTaxonomy';

export class AnimaliaListingResult {
  constructor(
    public readonly items: ReadonlyArray<AnimaliaListItem>,
    public readonly taxonomy: AnimaliaListingTaxonomy | null,
  ) {}
}
